/**
 * Chat Mode Component
 * Displays chat message history
 */

import React from 'react';
import ChatMessages from 'components/ChatMessages';
import { ChatMessage } from 'types/types';

interface ChatModeProps {
  isActive: boolean;
  chatHistory: ChatMessage[];
  debugMessages?: Array<{message: string, timestamp: number, direction: 'sent' | 'received'}>;
  onCopyToPrompt?: (content: string) => void;
  dispatchToast: (content: React.ReactElement, options?: { intent?: 'success' | 'error' | 'warning' | 'info'; timeout?: number }) => void;
}

export function ChatMode({ isActive, chatHistory, debugMessages = [], onCopyToPrompt, dispatchToast }: ChatModeProps) {
  if (!isActive) return null;

  return (
    <div className="content large">
      <ChatMessages history={chatHistory} onCopyToPrompt={onCopyToPrompt} dispatchToast={dispatchToast} />
      {debugMessages.map((item, index) => (
        <div 
          key={`debug-${index}`} 
          className={`debug-message ${item.direction}`}
        >
          {item.message}
        </div>
      ))}
    </div>
  );
}

export default ChatMode;
